import React from 'react'

import clsx from 'clsx'

import BuildConfig from '$extensionSrc/buildConfig'
import ScoreGauge from '$extensionSrc/components/ImpactMetrics/ScoreGauge'
import StatusDot from '$extensionSrc/components/ImpactMetrics/StatusDot'
import {
  ScoreStatus,
  getStatusDotColorForStatus,
} from '$extensionSrc/components/ImpactMetrics/types'

import styles from './OverallSummary.module.scss'

function formatTime(date: Date) {
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  })
}

export default function OverallSummary({
  lastUsedOn,
  score,
  status,
  summary,
}: {
  lastUsedOn: Date
  score: number
  status: ScoreStatus
  summary: string
}) {
  const now = new Date()
  const startOfDayLocal = new Date(new Date().setHours(0, 0, 0, 0))
  const usedBlockPartyToday = lastUsedOn >= startOfDayLocal

  return (
    <div className="OverallSummary">
      <div className={styles.header}>
        <div className={styles.title}>
          <div className="heading1 bold">
            Your {BuildConfig.TENANT_NAME} protection score:
          </div>
          <div className={styles.status}>
            <StatusDot color={getStatusDotColorForStatus(status)} />
            <span className="heading1">{status}</span>
          </div>
        </div>
        <ScoreGauge score={score} />
      </div>
      <div className={clsx(styles.summary, 'body1')}>{summary}</div>
      <div className={styles.footer}>
        {usedBlockPartyToday && (
          <div className="body1 darker-gray">
            You last used {BuildConfig.TENANT_NAME} today at{' '}
            {formatTime(lastUsedOn)}.
          </div>
        )}
        <div className="body1 darker-gray">
          This report was generated today at {formatTime(now)}.
        </div>
      </div>
    </div>
  )
}
